import script from "./QModalActsVisit.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalActsVisit.vue?vue&type=script&setup=true&lang=js"

import "./QModalActsVisit.vue?vue&type=style&index=0&id=64771f19&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64771f19"]])

export default __exports__